import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useIntl } from 'react-intl';
import { useMemo } from 'react';
import { mapInvoiceStreamName } from '@/shared/services/ObjectDisplayService';
import AutoComplete from './select/AutoComplete';
export const InvoiceStreamSelect = ({ initialValue, placeholder, onChange, invoiceStreams, }) => {
    const intl = useIntl();
    const items = useMemo(() => {
        var _a;
        return (_a = invoiceStreams === null || invoiceStreams === void 0 ? void 0 : invoiceStreams.filter(x => x.isActive || (!!initialValue && x.id === initialValue))) === null || _a === void 0 ? void 0 : _a.map(item => ({
            key: item.id,
            label: mapInvoiceStreamName(item, intl),
        }));
    }, [invoiceStreams, intl, initialValue]);
    const initialSelectedItem = useMemo(() => { var _a; return (_a = (initialValue && (items === null || items === void 0 ? void 0 : items.find(item => (item === null || item === void 0 ? void 0 : item.key) === initialValue)))) !== null && _a !== void 0 ? _a : undefined; }, [initialValue, items]);
    return (_jsx(AutoComplete, { items: items, initialSelectedItem: initialSelectedItem, placeholder: placeholder, mode: "edit", onChange: item => onChange(item === null || item === void 0 ? void 0 : item.key) }));
};
